<template>
<svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-color-key`]" width="1em" height="1em" v-bind="$attrs"><path d="M330.924671 486.843986L4.974452 814.32998v204.770163h204.770162v-116.938389h116.938389v-117.011522h117.011522l93.097291-92.146573a358.347784 358.347784 0 1 0-205.867145-206.232806zM665.577622 477.921857a119.424884 119.424884 0 1 1 0-238.849768 119.424884 119.424884 0 0 1 0 238.849768z" :fill="useCurrentColor ? 'currentColor' : '#FFA000'"/></svg>
</template>
<script>

export default {
  name: 'IconColorKey',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
